import { SetFailureStateAndRouteToFailure, FailureContinuation } from './actions/FailureActions';
import { TranscriptionRoutePathNames } from './routes';
import { NetworkError, NetworkErrors } from '../utils/Errors';
import { LOAD_TRANSCRIPTION_STRINGS_FAILURE_MESSAGE } from './LoadTranscriptionStrings';
import { LogEventNames } from '../backend/interfaces/ITelemetryLogger';

// Monitors user's network connection status and manages UI accordingly.
export class NetworkConnectionMonitor {
    private history: any;
    private wentOffline: boolean = false;
  
    private onOnline = () => {
      if (!this.wentOffline)
        return;

      // Refresh add-in to start recovery experience.
      location.reload();
    }

    private onOffline = () => {
      // Only show offline error message in Recording page.
      if (this.history.location.pathname != TranscriptionRoutePathNames.Recording)
        return;
      
      this.wentOffline = true;
    
      // Once the user goes offline, we don't care about them going offline again.
      window.removeEventListener('offline', this.onOffline);

      // Navigate to the failure page.
      // TranscriptionStrings can be null if the user goes offline before TranscriptionStrings is loaded during boot.
      SetFailureStateAndRouteToFailure(
        LogEventNames.Warning, 
        TranscriptionStrings != null ? TranscriptionStrings.RecordingLostConnectionFailureReason : LOAD_TRANSCRIPTION_STRINGS_FAILURE_MESSAGE, 
        FailureContinuation.None /*failureContinuation*/, 
        this.history);
    }
  
    constructor (history: any) {
      this.history = history;
    }
  
    public Start() {
      window.addEventListener('online', this.onOnline);
      window.addEventListener('offline', this.onOffline);
    }
}

// Throws error if the user is not online
export function CheckNetworkConnection() {
    if (navigator.onLine !== true) {
        throw new NetworkError(NetworkErrors.NoInternetConnection, "User is not connected to the internet");
    }
}